import React, { useState, useEffect } from 'react';
import Loader from '@components/common/Loader/newLoaderModal';
import FullWithModal from '@components/common/Modal/FullWidthModal';
import { ReactComponent as SuccessIcon } from '@assets/images/check_circle.svg';
import { ReactComponent as CrossIcon } from '@assets/images/receiptCancel.svg'
import cn from 'classnames';
import styles from './modal.module.scss';
import { TouchableButton } from '../common/Touchable/index';
import { LABEL } from '../../veriables';

const Modal = (props) => {

  // Props Destructuring
  const {
    isOpen,
    loading,
    handleReceiptPopUpOpen,
    orderingPortraitOrientation,
    handlePrint,
    tHead,
    rowData,
    receiptOpen,
    isLandScape,
    serverAppTheme,
    isMultiSelect,
    receiptPrintStatus,
    handleErrorPopUp,
    setReceiptPrintStatus,
    setErrorPopUp,
    clearSelectionOnAction = false,
  } = props

  // State Management
  const [checkArray, setCheckArray] = useState([]);
  const [data, setData] = useState([]);
  const [replaceData, setReplaceData] = useState([]);
  const deviceInfo = JSON.parse(window.sessionStorage.getItem('deviceInfo'));
  const receiptTypes = deviceInfo?.deviceGroup?.receiptTypes;
  const checkboxDisable = !receiptTypes?.print && !receiptTypes?.email && !receiptTypes?.sms;

  // React Hooks
  useEffect(() => {
    const ticketsData = rowData.tickets.map((item) => {
      let ticket = {};
      if (item.ticketStatusId === 1) {
        ticket = {
          ...item,
          printStatus: receiptPrintStatus && (receiptPrintStatus[item?.ticketId]?.succeded ? (
            <div className={cn("mx-0 row align-items-center justify-content-center text-center")}>
              {/* <div className={cn(styles.paymentStatusCircle, styles.success)}>{'✔'}</div> */}
              <SuccessIcon />
            </div>
          ) : receiptPrintStatus[item.ticketId]?.failed && (
            <div className={cn("mx-0 row align-items-center justify-content-center text-center")} onClick={() => handleErrorPopUp(item.ticketId)}>
              {/* <div className={cn(styles.paymentStatusCircle, styles.failure)}>{'✘'}</div> */}
              <CrossIcon />
            </div>
          )),
          checkbox:
            <input
              className={cn('d-flex justify-content-center roundedSm', isLandScape ? styles.checkbox : (orderingPortraitOrientation ? styles.checkboxverticalmode : styles.checkboxPotrait))}
              style={{
                border: checkArray && `2px solid ${serverAppTheme?.primary_text}`,
                '--checkbox-checked-color': serverAppTheme?.checkbox_check_color,
                '--checkbox-checked-bg': serverAppTheme?.checkbox_checked,
                opacity: checkboxDisable && "0.2"
              }}
              type="checkbox"
              disabled={checkboxDisable}
              checked={checkArray.some((e) => e === item.id)}
              onChange={() => handleCheckBox(item.id)}
            />
        };
      }
      return { ...ticket };
    });
    if (data.length > 0) {
      setReplaceData(replaceData.concat(ticketsData));
      setData([]);
    } else {
      setReplaceData([]);
      setData(data.concat(ticketsData.filter((e) => Object.keys(e).length > 0)));
    }
  }, [rowData, checkArray, receiptPrintStatus]);



  // Methods
  const handleCheckBox = (e) => {
    if (!checkArray.includes(e)) {
      if (!isMultiSelect) setCheckArray(checkArray.splice(0));
      setCheckArray(checkArray.concat(e));
    } else {
      setCheckArray(checkArray.filter((f) => f !== e));
    }
  };
  const clearChekedState = () => setCheckArray([]);


  const tableHeader = () => {
    return tHead && tHead.map((item) => {
      return (
        <div key={item.name} className={cn('col border-5 fw-500 fs_14 text-center', item.key === 'checkbox' ? 'col-1 pl-2 pr-1' : item.key === 'paymentStatus' ? 'pr-1 pl-1' : 'px-1')}  >
          {item.name}
        </div>
      );
    });
  };
  const formatCardNumber = (cardNumber, cardType) => {
    if (!cardNumber) return '';
    const str = String(cardNumber);
    if (str.length <= 8) return str;
     if (!cardType) {
      return `xxx${str.slice(-4)}`;
    } else {
      return `${str.slice(0, 4)}******${str.slice(-4)}`;
    }
  };
  const tBody = () => {
    if (data.length > 0) {
      return data.filter((f) => Object.keys(f).length > 0).map((e, index) => {
        return (
          <div key={e.id} className={cn('col-12 px-0 row mx-0  fs_12 fw-400', checkArray.some((ele) => ele === e.id) ? `fs_12` : '')} style={{ borderBottom: serverAppTheme?.popupBorder, background: checkArray.some((ele) => ele === e.id) ? serverAppTheme?.receipt_select_bg :  serverAppTheme?.popUp_bg}} >
            {
              tHead && tHead.map((item) => {
                return <div className={cn(styles.rowPadding, 'col py-2 border-5 fs_12 fw-400 text-center', item.key === 'checkbox' ? 'col-1 pr-1 pl-2 ' : item.key === 'paymentStatus' ? `pr-2 pl-1` : `${styles.wordBreak} pr-2 pl-1`, orderingPortraitOrientation ? '' : 'pl-3')} key={item.key}>{item.prefix
                  ? `${item.prefix}${Number(e[item.key]).toFixed(2)}`
                  : item.key === 'redactedCardNumber'
                    ? formatCardNumber(e[item.key], e.cardType)
                    : e[item.key]}</div>;
              })
            }
          </div>
        );
      });
    }
    return replaceData.filter((f) => Object.keys(f).length > 0).map((e, index) => {
      return (
        <div key={e.id} className={cn('col-12 px-0 row mx-0 fs-14', checkArray.some((ele) => ele === e.id) ? `fs_12` : '')} style={{ borderBottom: serverAppTheme?.popupBorder, background: checkArray.some((ele) => ele === e.id) && serverAppTheme?.receipt_select_bg }}>
          {
            tHead && tHead.map((item) => {
              return <div className={cn('col py-2 border-5 fs_12 text-center', item.key === 'checkbox' ? 'col-1 pl-2 pr-1 ' : item.key === 'paymentStatus' ? 'pr-2 pl-1' : `${styles.wordBreak} pr-2 pl-1`, styles.rowPadding, orderingPortraitOrientation ? '' : 'pl-3')} key={item.key}>{item.prefix ? `${item.prefix}${Number(e[item.key]).toFixed(2)}` : item.key === 'redactedCardNumber' ? formatCardNumber(e[item.key], e.cardType) : e[item.key]}</div>;
            })
          }
        </div>
      );
    });
  };

  // HTML CSS CODE
  return (
    <div className="">
      {loading
        && <div><Loader /></div>}
      <FullWithModal
        isOpen={isOpen}
        isModalCenter
        customClass2={cn("w-100 h-100 position-relative")}
        noBackground
        style={{display:'flex', flexDirection:'column', width:'100%', height:'100%',pointerEvents:'auto',backgroundColor: serverAppTheme?.popUp_bg, backgroundClip:'padding-box', border: "0", boxShadow: serverAppTheme?.popUp_box_shadow}}
      >
        <div className={cn("col-12 m-auto justify-content-center align-items-center text-center p-0")} style={{ color: serverAppTheme?.primary_text }}>
          <div className={cn('col-12 py-1 px-2 d-flex', styles.moretitlebg)}>
            <div className='col-4 p-0 fs_16  text-left'>
              {rowData?.tab ? "Tab" : "Table"}:
              {(rowData?.stationName?.length > 8
                ? rowData?.stationName.substring(0, 8) + "..."
                : rowData?.stationName)}
            </div>
            <div className='col-4 p-0 text-center'>{LABEL().CHK_RS_RECEIPT_SCREEN}</div>
            <div className='col-4 p-0 text-right fs_16'>#{rowData?.number}</div>
          </div>
          {/* <div className='col-12 px-0 d-flex text-left fw-500'>
            <div className={cn(isLandScape ? 'col-8 ' : 'col-7', ' px-0 d-flex flex-column fs_12')}>
              <div>Server : {rowData?.employeeFirstName}</div>
              <div>Table : {rowData?.stationNumber}</div>
            </div>
            <div className={cn(isLandScape ? 'col-4' : 'col-5', 'px-0 fs_12')}>
              <div className='col-12 px-0 d-flex'>
                <div className={cn('col-8 pr-0 text-left', isLandScape ? 'pl-5' : 'pl-3')}>Total Amount</div>
                <div className='col-4 px-0 text-right'>{LABEL().CURRENCY_SYMBOL}{rowData?.totalAmount}</div>
              </div>
              <div className='col-12 px-0 d-flex'>
                <div className={cn('col-8 pr-0 text-left', isLandScape ? 'pl-5' : 'pl-3')}>Paid Amount</div>
                <div className='col-4 px-0 text-right'>{LABEL().CURRENCY_SYMBOL}{rowData?.paidAmount}</div>
              </div>
              <div className='col-12 px-0 d-flex'>
                <div className={cn('col-8 pr-0 text-left', isLandScape ? 'pl-5' : 'pl-3')}>Unpaid Amount</div>
                <div className='col-4 px-0 text-right'>{LABEL().CURRENCY_SYMBOL}{rowData?.unpaidAmount}</div>
              </div>
            </div>
          </div> */}
          <div className={cn('col-12', orderingPortraitOrientation ? 'mt-3 px-12' : 'mt-2')}>
            <div className='col-12 px-0 py-2 text-center fw-600'>{LABEL().SELECT_CARD}</div>
            <div className={cn("col-12 row mx-0 p-0 justify-content-center", orderingPortraitOrientation ? 'mt-3' : '', styles.tablecontainer ,orderingPortraitOrientation ?  styles.ContainerHeight : styles.Receiptheight)} style={{ border: serverAppTheme?.popupBorder }}>
              <div className={cn('col-12 px-0 fs_14 rounded-top position-sticky', styles.positionValue)} style={{ background: serverAppTheme?.popUp_bg, borderBottom: serverAppTheme?.popupBorder }}>
                <div className={cn('row mx-0', orderingPortraitOrientation ? 'py-3' : 'py-1')}>
                  {tableHeader()}
                </div>
              </div>
              <div className='col-12 px-0'>
                {tBody()}
              </div>
            </div>
          </div>
          <div className={cn("row mx-0 fs-18 pt-3 col-12 justify-content-center fixed-bottom", orderingPortraitOrientation ? ' px-12' : 'pb-4')}>
            <div className={cn('pl-0', isLandScape ? 'col-3 pr-1' : (orderingPortraitOrientation ? 'col-6' : 'col-3'))} style={{ paddingRight: !isLandScape && "8px" }}>
              <TouchableButton 
                style={{ 
                  color: serverAppTheme?.cancleBtn_font,
                  backgroundColor: serverAppTheme?.OFF_Premise_Btn,
                  border: serverAppTheme?.cancleBtn_Border,
                  lineHeight: '0.8', 
                  opacity: 1 
                }} 
                className={cn("col-12 px-0  btn-ripple btn-lg fs_24 fw-600",orderingPortraitOrientation ? 'btn68' : 'btn44')}
                onClick={(e) => { 
                  e.preventDefault()
                  receiptOpen(); 
                  setReceiptPrintStatus({});
                }}
                rippleEffect={true}
              >
                {LABEL().CANCEL}
              </TouchableButton>
            </div>
            {
              receiptTypes?.print && (
                <div
                  className={cn("pl-0", isLandScape ? "col-3 pr-1" : (orderingPortraitOrientation ? 'col-6 pb-2 pr-0' : 'col-3'))}
                  style={{ paddingRight: !isLandScape && "8px" }}
                >
                  <TouchableButton
                    type="submit"
                    style={{
                      backgroundColor: serverAppTheme?.secondaryBtn,
                      color: serverAppTheme?.btn_font_color,
                      borderRadius: "8px",
                      lineHeight: "0.8",
                      opacity: 1,
                    }}
                    className={cn("col-12 px-0  btn-ripple btn-lg fs_24 fw-600", orderingPortraitOrientation ? 'btn68' : 'btn44')}
                    onClick={() => {
                      if (checkArray.length === 0) {
                        setErrorPopUp({
                          res: `Please select receipt(s) to print`,
                          noErrorTxt: true,
                        });
                      } else {
                        handlePrint(rowData, checkArray, clearChekedState);
                        if (clearSelectionOnAction) clearChekedState();
                      }
                    }}
                    rippleEffect={true}
                  >
                    {LABEL().PRINT}
                  </TouchableButton>
                </div>
              )
            }
            {
              receiptTypes?.email && (
                <div
                  className={cn("pl-0", isLandScape ? "col-3 pr-1" : (orderingPortraitOrientation ? 'col-6 pb-2' : 'col-3'))}
                  style={{ paddingRight: !isLandScape && "8px" }}
                >
                  <TouchableButton
                    type="submit"
                    style={{
                      backgroundColor: serverAppTheme?.secondaryBtn,
                      color: serverAppTheme?.btn_font_color,
                      borderRadius: "8px",
                      lineHeight: "0.8",
                      opacity: 1,
                    }}
                    className={cn("col-12 px-0  btn-ripple btn-lg fs_24 fw-600", orderingPortraitOrientation ? 'btn68' : 'btn44')}
                    onClick={(event) => {
                      event.preventDefault();
                      if (checkArray.length === 0) {
                        setErrorPopUp({
                          res: `Please select receipt(s) to email`,
                          noErrorTxt: true,
                        });
                      } else {
                        handleReceiptPopUpOpen(
                          rowData,
                          checkArray,
                          "email",
                          clearChekedState,
                        );
                        if (clearSelectionOnAction) clearChekedState();
                      }
                    }}
                    rippleEffect={true}
                  >
                    {LABEL().EMAIL}
                  </TouchableButton>
                </div>
              )
            }
            {
              receiptTypes?.sms && (
                <div className={cn("pl-0 pr-0", isLandScape ? "col-3" : (orderingPortraitOrientation ? 'col-6' : 'col-3'))}>
                  <TouchableButton
                    type="submit"
                    style={{
                      backgroundColor: serverAppTheme?.secondaryBtn,
                      color: serverAppTheme?.btn_font_color,
                      borderRadius: "8px",
                      lineHeight: "0.8",
                      opacity: 1,
                    }}
                    className={cn("col-12 px-0  btn-ripple btn-lg fs_24 fw-600", orderingPortraitOrientation ? 'btn68' : 'btn44')}
                    onClick={(event) => {
                      event.preventDefault();
                      if (checkArray.length === 0) {
                        setErrorPopUp({
                          res: `Please select receipt(s) to text`,
                          noErrorTxt: true,
                        });
                      } else {
                        handleReceiptPopUpOpen(
                          rowData,
                          checkArray,
                          "phone",
                          clearChekedState,
                        );
                        if (clearSelectionOnAction) clearChekedState();
                      }
                    }}
                    rippleEffect={true}
                  >
                    {LABEL().TEXT}
                  </TouchableButton>
                </div>
              )
            }
          </div>
        </div>
      </FullWithModal>
    </div>
  );
};
export default Modal;
